export default __webpack_public_path__ + "static/media/Download.3135e93f.svg";